import React from "react";
import useStore from "../zustand/useStore";
import MatrimonialPortalRoleComponent from "../components/MatrimonialPortalRoleComponent";
import MatrimonialMobileDashboardPage from "../components/MatrimonialMobileDashboardPage";

export default function MatrimonialMobilePage({renderHeaderPage,isMobile}) {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;

    if(userInfo?.matrimonial_portal_role) {
        return (
            <MatrimonialMobileDashboardPage isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
        )
    } else {
        return (
            <MatrimonialPortalRoleComponent isMobile={isMobile} renderHeaderPage={renderHeaderPage}/>
        );
    }
}
